/**
 * userState.js — MIGRATED to React Query + apiClient pattern
 *
 * Before: raw axios + useState(loading/users) + useEffect
 * After:  useUsers() hook — one line replaces ~15 lines of boilerplate
 */
import React, { useEffect } from 'react'
import { Card, Table, Row, Col, Form } from 'antd';
import dayjs from 'dayjs';
import { useMyContext } from 'Context/MyContextProvider';
import { getCategoryPrice } from 'utils/billingPricing';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { useUsers } from 'hooks/api/useUsers';


const UserStates = () => {
    const { UserData, Permisson, navigate, isMobile } = useMyContext();

    useEffect(() => {
        if (!Permisson?.includes('View Cost Analysis')) {
            navigate('404')
        }
    }, [Permisson]);

    // ─── Before (15 lines of boilerplate):
    // const [loading, setLoading] = useState(false);
    // const [users, setUsers] = useState([]);
    // const UserList = () => {
    //   setLoading(true);
    //   apiClient.get(`${api}users`, { headers: { Authorization: 'Bearer ' + authToken } })
    //     .then(res => { setUsers(res.data.user); setLoading(false); })
    //     .catch(err => { setLoading(false); console.log(err); });
    // }
    // useEffect(() => { UserList(); }, []);

    // ─── After (1 line). No axios, no useState, no useEffect, no error handling boilerplate.
    // Data is cached — if another component already fetched /users, this hits cache instantly.
    const { data: users = [], isLoading: loading } = useUsers();

    const tableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            sorter: {
                compare: (a, b) => a.name.length - b.name.length,
            },
        },
        {
            title: 'Phone Number',
            dataIndex: 'phone_number',
            sorter: {
                compare: (a, b) => a.phone_number.length - b.phone_number.length,
            },
        },
        {
            title: 'Conversation Category',
            dataIndex: 'conversation_category',
            sorter: {
                compare: (a, b) => a.conversation_category?.length - b.conversation_category?.length,
            },
        },
        {
            title: 'Conversation Type',
            dataIndex: 'conversation_type',
            sorter: {
                compare: (a, b) => a.conversation_type?.length - b.conversation_type?.length,
            },
        },
        {
            title: 'Unique Conversations',
            dataIndex: 'conversation',
            sorter: {
                compare: (a, b) => a.conversation - b.conversation,
            },
        },
        {
            title: 'Cost',
            dataIndex: 'Cost',
            render: (_, record) => {
                const conversationType = record.conversation_category;
                if (conversationType === 'MARKETING') {
                    return `₹${(getCategoryPrice(UserData, 'marketing') * (record.conversation)).toFixed(2)}`;
                } else {
                    return `₹${(getCategoryPrice(UserData, 'utility') * (record.conversation)).toFixed(2)}`;
                }
            },
            sorter: {
                compare: (a, b) => a.conversation - b.conversation,
            },
        },
        {
            title: 'Date',
            dataIndex: 'start',
            render: date => <span>{dayjs.unix(date).format('DD/MM/YYYY')} </span>,
            sorter: (a, b) => a.start - b.start,
        },
    ];

    return (
        <Card bodyStyle={{ padding: '0px' }}>
            <div className="container-fluid">
                <Form
                    name="basicInformation"
                    layout={`${isMobile ? 'vertical' : 'horizontal'} `}
                >
                    <Row gutter={ROW_GUTTER} justify="space-between" align="middle" className="py-4">
                        <Col>
                            <h2>Analytics</h2>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className="table-responsive">
                <Table loading={loading} columns={tableColumns} dataSource={users} rowKey="id" />
            </div>
        </Card>
    );
};

export default UserStates
